export enum PackageFilterProvider {
  AIR = 'AIR',
  HOTEL = 'HOTEL'
}
